import { Box, Heading, Text } from 'native-base'

import { colors } from '../../utils/theme/configureTheme'

/** Hero image banner displayed at the top of the support feedback form. */
export default function SupportFeedbackHero() {
  return (
    <Box width="100%">
      <img
        src="/feedback-hero.jpg"
        alt="Veho driver delivering a package"
        style={{ width: '100%', height: '180px', objectFit: 'cover' }}
      />
      <Box px={4} pt={6} pb={4}>
        <Heading fontSize={24} fontWeight="700" fontFamily="bodyBold" color={colors.brand.softBlack} mb={2}>
          We value your feedback
        </Heading>
        <Text
          fontSize={14}
          fontWeight="400"
          color={colors.brand.softBlack}
          fontFamily="Matter Regular"
          lineHeight="150%"
        >
          Help us improve our customer support by sharing your experience!
        </Text>
      </Box>
    </Box>
  )
}
